import { ROUTES } from "domain/configuration";
import { getFlickSignUpRequestStatus } from "domain/core/selectors";
import { REQUEST_STATUS, RequestStatus } from "lib/types";
import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import { PartialSignUpDialog } from "ui/compounds/PartialSignUpDialog";

import Footer from "./components/Footer";
import Header from "./components/Header";
import { Address } from "./pages/Address";
import { Complete } from "./pages/Complete";
import { Details } from "./pages/Details";
import { Payment } from "./pages/Payment";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const RootLayout = () => {
  const flickSignUpStatus = useSelector(getFlickSignUpRequestStatus);
  const localSignUpUUID = localStorage.getItem("signUpId");

  const getSignUpCallComplete = useCallback(() => {
    if (!localSignUpUUID) return true;
    return [REQUEST_STATUS.Fulfilled, REQUEST_STATUS.Failed].some(
      (status: RequestStatus) => status === flickSignUpStatus,
    );
  }, [flickSignUpStatus]);

  return (
    <>
      <ScrollToTop />
      <Header />
      <PartialSignUpDialog />
      {getSignUpCallComplete() && (
        <main id="content" className="background--echo">
          <Outlet />
        </main>
      )}
      <Footer />
    </>
  );
};

// TODO: Remove tailwind package
export const App: React.FC = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<RootLayout />}>
        <Route path={ROUTES.details} element={<Details />} />
        <Route path={ROUTES.payment} element={<Payment />} />
        <Route path={ROUTES.complete} element={<Complete />} />
        {/* Default route '/' - needs to be last - first to match is served */}
        <Route path={ROUTES.address} element={<Address />} />
      </Route>,
    ),
  );

  return <RouterProvider router={router}></RouterProvider>;
};
